import React from 'react'
import styles from './HomeCTASection.module.sass'
import Grid from '../Grid'
import CallToActionLink from '../CallToActionLink'
import Typography from '../Typography'
import CloudDownloadIcon from '../../icons/CloudDownloadIcon'
import routes from '../../routes'

const baseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://shoobphoto.com'
const href = (link) => `${baseUrl}${link}`

const HomeCTASection = () =>
  
(
  <Grid container justify="space-evenly" maxWidth="sm" margin="auto" classes={styles.container}>
    <Grid item xs={12}>
      <Typography align="center">Did your purchase include a digital image?</Typography>
      <CallToActionLink
        icon={CloudDownloadIcon}
        text="Download Digital Image Here"
        url={routes.downloadImageForm()}
        bgColor="inherit"
      />
      
      <div className={styles.shoob_job} >
      <a className={styles.shoob_job_text}  href={href('/contacts/shoob_job')}>JOB OPENINGS</a></div>
    </Grid>
  </Grid>
)


export default HomeCTASection
